import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { UserProfile as Profile } from 'oidc-client-ts';

import type { RootState } from '../setup/store';

import { accessToken } from './accessToken';

export type AccessToken = string | undefined | null;

export interface AccessTokenState {
    accessToken: AccessToken;
    idToken: string | null;
    idTokenClaims: Profile | null;
}

const initialState: AccessTokenState = {
    accessToken: accessToken.getAccessToken(),
    idToken: null,
    idTokenClaims: null,
};

const tokenSlice = createSlice({
    name: 'tokenHandling',
    initialState,
    reducers: {
        accessTokenStored: (state, action: PayloadAction<AccessToken>) => {
            state.accessToken = action.payload;
        },
        idTokenStored: (state, action: PayloadAction<string | null>) => {
            state.idToken = action.payload;
        },
        idTokenClaimsStored: (state, action: PayloadAction<Profile>) => {
            state.idTokenClaims = action.payload;
        },
    },
});

export const { accessTokenStored, idTokenStored, idTokenClaimsStored } = tokenSlice.actions;

export const getAccessToken = (state: RootState) => state.tokenHandling?.accessToken ?? 'NO_ACCESS_TOKEN_AVAILABLE';
export const getIdToken = (state: RootState) => state.tokenHandling?.idToken ?? null;
export const getIdTokenClaims = (state: RootState) => state.tokenHandling?.idTokenClaims ?? null;

export default tokenSlice.reducer;
